var constants = {
  default: {
    froala: {
      key: `${process.env.BASE_FROALA_KEY}`,
      attribution: false,
      imageUploadURL: `${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/download_files/upload`,
      imageUploadMethod: 'PUT',
      toolbarInline: false,
      quickInsertTags: [],
      charCounterCount: false,
      initOnClick: true,
      toolbarButtons: {

        'moreText': {

          'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],

          'buttonsVisible': 3

        },

        'moreParagraph': {

          'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],

          'buttonsVisible': 3

        },

        'moreRich': {

          'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],

          'buttonsVisible': 2

        }

      }
    }
  }
}

export default constants



// WEBPACK FOOTER //
// ./src/assets/constants.js